import React from 'react';

import {useTournamentAppConfiguration} from "../utils/tournamentconfig/TournamentConfiguration"

function Footer() {
    const tournamentAppConfiguration = useTournamentAppConfiguration()

    return (
        <footer className="footer">
            <p>
                Support: <a
                href="mailto:FliPal@mikedg.com">FliPal@mikedg.com</a> | {tournamentAppConfiguration.copyrightMessage} |
                FliPal &copy; {new Date().getFullYear()} | <a
                href="https://paypal.me/mikedg0" target="_blank" rel="noopener noreferrer">Help cover hosting costs and/or tip Mike DG</a>
            </p>
        </footer>
    )
}

export default Footer;